<div class="grid-container">
    <a class="category-link" *ngFor="let item of categoryList" [routerLink]="[item.url]">
        <div class="category-item">
            <div class="avatar-co">
                <img
                    class="avatar"
                    [src]="item.avatar"
                    [alt]="item.name"
                />
            </div>
            <div class="context-co">
                <p class="title">{{item.name}}</p>
            </div>
        </div>
    </a>
</div>
